import { BsFilter, BsTrash } from 'react-icons/bs';
import styles from './BrandTable.module.scss'
import { Button, Modal, Table } from "reactstrap";
import { getLocalUser, getLocalUserId } from '../../../components/functions/utilities';
import NodataImage from "../../../resources/images/no-data.svg";
import { ExtendedUser, User } from '../../../interfaces/interfaces';
import MeritoButton from '../../../components/common/MeritoButtons/MeritoButtons';
import { useNavigate } from 'react-router';
import { useEffect } from 'react';

enum ConnectionStatusEnum {
  InviteSent = 'Invite Sent',
  ReadyToConnect = 'Ready to Connect',
  Connected = 'Connected',
  SetupIncomplete = 'Setup Incomplete'
}

export enum ActionButtonText {
  ConnectNow = 'Connect Now',
  ConnectMoreChannels = 'Connect More Channels',
  AddWorkspaces = 'Add Workspaces',
  ConnectSalesChannel = 'Connect Sales Channel'
}

interface ConnectionStatus {
  status: string;
  actionBtn?: {
    btnText: string;
    redirectUrl: string;
  };
}

type Props = {
  userDisplayList: any[],
  activityStatus: any,
  setSelectedUser: Function,
  toggle: Function,
  setShowEllipsis: Function
}

const BrandTable = ({ userDisplayList, activityStatus, setSelectedUser, toggle, setShowEllipsis }: Props) => {
  console.log('userDisplayList', userDisplayList)
  const currentUser = getLocalUser()
  const navigate = useNavigate();

  const getStatus = (status: 'PENDING' | 'FAILURE' | 'SUCCESS', companyId: number) => {
    if (activityStatus) {
      const isWorkspaceAdded = activityStatus[companyId]?.isWorkspaceAdded
      const isSalesChannelConnected = activityStatus[companyId]?.isSalesChannelConnected
      const isAdsChannelConnected = activityStatus[companyId]?.isAdsChannelConnected
      if (status == 'PENDING') {
        return {
          status: ConnectionStatusEnum.InviteSent,
          actionBtn: {
            btnText: '',
            redirectUrl: ''
          }
        }
      } else if (isWorkspaceAdded && isSalesChannelConnected) {
        return {
          status: ConnectionStatusEnum.Connected,
          actionBtn: {
            btnText: ActionButtonText.ConnectMoreChannels,
            redirectUrl: `/workspaceStore?cid=${companyId}`
          }
        }
      } else if (isSalesChannelConnected) {
        return {
          status: ConnectionStatusEnum.SetupIncomplete,
          actionBtn: {
            btnText: ActionButtonText.AddWorkspaces,
            redirectUrl: `/workspaceStore?cid=${companyId}`
          }
        }
      } else if (isAdsChannelConnected) {
        return {
          status: ConnectionStatusEnum.SetupIncomplete,
          actionBtn: {
            btnText: ActionButtonText.ConnectSalesChannel,
            redirectUrl: `/workspaceStore?cid=${companyId}`
          }
        }
      } else {
        return {
          status: ConnectionStatusEnum.ReadyToConnect,
          actionBtn: {
            btnText: ActionButtonText.ConnectNow,
            redirectUrl: `/workspaceStore?cid=${companyId}`
          }
        }
      }
    } else {
      return {
        status: '',
        actionBtn: {
          btnText: '',
          redirectUrl: ''
        }
      }
    }
  }

  return (
    <Table borderless>
      <thead className={styles.tableHeader}>
        <tr>
          <th>
            Brand Name
          </th>
          <th colSpan={1}>
            Brand Contact
          </th>
          <th>
            Email
          </th>
          <th>
            Phone
          </th>
          <th>
            Status
          </th>
          <th>
            Actions
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {userDisplayList && userDisplayList.length > 0 ? (
          <>
            {
              (() => {
                let connectedCount = 0;
                let hasNonConnected = false;

                const rows = userDisplayList.map((user: ExtendedUser, index) => {
                  const brandInviteStatus: ConnectionStatus = getStatus(user.inviteStatus, user.companyId);
                  const isConnected = brandInviteStatus.status === ConnectionStatusEnum.Connected;

                  if (isConnected) {
                    connectedCount += 1;
                  } else {
                    hasNonConnected = true;
                  }

                  const statusClass = brandInviteStatus.status.trim().replace(/\s+/g, '').toLowerCase();

                  return (
                    <tr
                      className={`border-bottom`}
                      key={`${index}-${user.companyName}`}
                    >
                      <td>
                        <div className={styles.nameContainer}>
                          <p className={styles.name}>{user.companyName}</p>
                          <p className={styles.designation}>{user.category}</p>
                        </div>
                      </td>
                      <td>{user.name}</td>
                      <td>{user.email}</td>
                      <td>
                        <div style={{ paddingLeft: user.phoneNumber ? 0 : "2rem" }}>
                          {user.phoneNumber ? user.phoneCode + user.phoneNumber : "-"}
                        </div>
                      </td>
                      <td>
                        <div className={`${styles.status} ${styles[statusClass]}`}>
                          <div></div>
                          <p>{brandInviteStatus.status}</p>
                        </div>
                      </td>
                      <td>
                        {
                          brandInviteStatus.actionBtn.btnText === '' ? '-' :
                            <MeritoButton
                              type='primary-1'
                              size='md'
                              btnText={brandInviteStatus.actionBtn.btnText}
                              onClick={() => navigate(brandInviteStatus.actionBtn.redirectUrl)}
                            />
                        }
                      </td>
                      <td>
                        <div className={styles.tdActions}>
                          <div
                            style={{
                              cursor:
                                getLocalUserId() !== user.id.toString() ? "pointer" : "not-allowed",
                            }}
                            className={`${styles.icon} ${styles.editButton} ${getLocalUserId() !== user.id.toString() ? styles.iconhover : ""
                              }`}
                            onClick={(e) => {
                              if (getLocalUserId() !== user.id.toString()) {
                                e.stopPropagation();
                                setSelectedUser(user);
                                toggle();
                              }
                            }}
                          >
                            <BsTrash className={styles.delete} />
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                });

                setShowEllipsis(hasNonConnected);
                return rows;
              })()
            }
          </>) : (
          <tr style={{ borderBottom: "none" }}>
            <td colSpan={7} className="text-center">
              <p className={styles.noData}>No brands match your search criteria.</p>
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  )
}

export default BrandTable;